export default (permission, permissions) => permissions.includes(permission);
